import React from 'react';
import { ArrowRight, Smartphone } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const HeaderSection = () => {
  return (
    <BusinessHero
      title="Apps, die dein Business verwandeln"
      titleHighlight="Mobile App Entwicklung"
      description="Stell dir vor, deine Kunden hätten dein Unternehmen immer in der Hosentasche. Wir entwickeln Apps, die nicht nur funktionieren - sie begeistern und bringen echten Mehrwert."
      details="Von der ersten Idee bis zur App im Store: Wir verwandeln deine Vision in eine mobile Realität. Unsere Apps laufen perfekt auf iOS und Android - schnell, schön und perfekt auf deine Bedürfnisse zugeschnitten."
      backgroundStyle="blue"
      primaryCTA={{
        label: "App-Möglichkeiten entdecken",
        href: "#mobile-possibilities"
      }}
      secondaryCTA={{
        label: "Deine App-Idee besprechen",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default HeaderSection; 